import { Component } from '@angular/core';

@Component({
    selector: 'auth-resetpwdsuccess',
    templateUrl: './resetpwdsuccess.component.html'
})
export class ResetPwdSuccessComponent {
    constructor() {
    }


}
